import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/footer.css";

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      {/* Logo Section */}
      <div className="footer-logo-container">
        <img src="/logo.png" alt="Company Logo" className="footer-logo" />
      </div>

      {/* Company Name */}
      <h3 className="footer-company-name">{t("footer.companyName")}</h3>

      {/* Contact Details */}
      <div className="footer-contact">
        <p>
          <span className="icon-location"></span> {t("footer.address")}
        </p>
        <p>
          <span className="icon-phone"></span>
          <a href="tel:+213661600444">{t("footer.phone1")}</a> |
          <a href="tel:+213561625049">{t("footer.phone2")}</a>
        </p>
        <p>
          <span className="icon-fax"></span> {t("footer.faxNumber")}
        </p>
        <p>
          <span className="icon-email"></span>
          <a href="mailto:sarlbelamriinchataamir@gmail.com">
            sarlbelamriinchataamir@gmail.com
          </a>
        </p>
      </div>

      {/* Divider */}
      <hr className="footer-divider" />

      {/* Copyright */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} {t("footer.rights")}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
